module.exports = __webpack_public_path__ + "img/bac_03.78bf20b4.png";